import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = (theme) => css`
  width: 100%;
  max-width: 754px;
  margin: 0 auto;
  padding: ${theme.spacing(0, 3, 3)};
`

export const title: Interpolation<Theme> = (theme) => css`
  display: block;

  margin: ${theme.spacing(3)};

  line-height: 42px;
  font-weight: 700;
`

export const mainTitle: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: ${theme.typographyColors.typographyTwo};
  margin: 0 0 ${theme.spacing(3)};
`

export const divider: Interpolation<Theme> = (theme) => css`
  margin-bottom: ${theme.spacing(3)};
`

export const content: Interpolation<Theme> = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const readOnly: Interpolation<Theme> = css`
  padding: 0 9px;
`

export const removeButton: Interpolation<Theme> = css`
  svg {
    height: 22px;
    width: 22px;
  }
`

export const buttonsWrapper: Interpolation<Theme> = css`
  display: flex;
  justify-content: space-between;

  & > div {
    display: flex;
    gap: 10px;
  }
`
